module.exports = __webpack_public_path__ + "img/dimitris-petrakis.9a72970f.jpg";